export default "__VITE_ASSET__Bknfz_N3__"